import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import {UpdateTransactionMapDetailsInput, UpdateTransactionMapDetailsPayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_MAP = gql`
    mutation updateMapDetails($input: UpdateTransactionMapDetailsInput!){
        updateTransactionMapDetails(input: $input){
            message
            errors {
                code
                message
            }
            result
            transactionMapId
        }
    }
`;

export const mutationUpdateMapDetails = async (
    client: ApolloClient<NormalizedCacheObject>,
    dataToUpdate: UpdateTransactionMapDetailsInput
): Promise<UpdateTransactionMapDetailsPayload | undefined> => {
    const { transactionId, description, standardVersion, id } = dataToUpdate;
    const { data, errors } = await client.mutate<{ updateTransactionMapDetails: UpdateTransactionMapDetailsPayload}>({
        variables: { 
            input: { 
                id,
                description,
                standardVersion, 
                transactionId, 
            } 
        },
        mutation: MUTATION_UPDATE_MAP
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the transaction map save.');
    }
    if (data && data.updateTransactionMapDetails) {
        return data.updateTransactionMapDetails;
    }

    return undefined;
};